var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { baseApi } from "@madmedical/store";
const api = baseApi
    .enhanceEndpoints({ addTagTypes: ["comments"] })
    .injectEndpoints({
    endpoints: (build) => ({
        getComments: build.query({
            query: (_a) => {
                var { patientId } = _a, params = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/comments`,
                    params,
                });
            },
            providesTags: ["comments"],
        }),
        getComment: build.query({
            query: (id) => `medical/comments/${id}`,
        }),
        createComment: build.mutation({
            query: (_a) => {
                var { patientId } = _a, body = __rest(_a, ["patientId"]);
                return ({
                    url: `medical/patients/${patientId}/comments`,
                    method: "POST",
                    body,
                });
            },
            invalidatesTags: ["comments"],
        }),
        deleteComment: build.mutation({
            query: (id) => ({
                url: `medical/comments/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["comments"],
        }),
    }),
});
export const { useGetCommentsQuery, useGetCommentQuery, useCreateCommentMutation, useDeleteCommentMutation, } = api;
